import FactoryComponents from '../../../../../../factory/components/FactoryComponents.js';
const root = {}
export default root
root.name = 'processTwo';
root.props = {processData: Object, deptDatas: Array, userDatas: Array, thisId: Number, success: Function};
root.data = {
	dangerGovernData:{
		cacheData:{},
		
	}
}
root.methods = {
	
	//审核成功
	successApproval: function(){
		const that = this;
		const formData = new FormData();
		formData.append("id", this.processData.approveInfoVo.id);
		formData.append("hiddenGovernId", this.processData.id);
		formData.append("approvalOpinion", this.dangerGovernData.cacheData.approvalOpinion==null?"":this.dangerGovernData.cacheData.approvalOpinion);
		this.componentsMoudel.startPost('/approveInfo/update', formData, true).then(res => {
			that.success(that.processData, 2);
		})
	},
	
	//审核失败
	failApproval: function(){
		const that = this;
		const formData = new FormData();
		formData.append("status", 0);
		formData.append("id", this.processData.id);
		this.componentsMoudel.startPost('/hiddenGovern/updateStatus', formData, true).then(res => {
			that.success(that.processData, 0);
		})
	}
	
}

root.watch = {
	processData: function(newProcessData, oldProcessData){
		if(newProcessData.approveInfoVo && newProcessData.approveInfoVo !== null){
			this.dangerGovernData.cacheData = this.processData.approveInfoVo;
		}
	}
}

FactoryComponents.initComponent(root);